
export interface I_Fy3IrcTextureItem {
    /** 描述 */
    label: string,
    /** 卫星名称 */
    satellite: Enum__Fy3IrcTextureSatelliteType,
    /** 设别名称 */
    el: Enum__Fy3IrcTextureSensorElement,
    /** 升降轨标识 */
    ad?: Enum__Fy3IrcTextureAdType,
    /** 使用接口 */
    UserApiType: Enum__Fy3IrcUserApiType
}

export enum Enum__Fy3IrcTextureSensorElement {
    "红外云图" = "IRC",
    "红外云图(色彩增强)" = "IRCE",
    "可见光云图" = "VISC",
    "水汽云图" = "WVC"
}

export enum Enum__Fy3IrcTextureAdType {
    升轨 = "A", 
    降轨 = "D",
};


export enum Enum__Fy3IrcTextureSatelliteType {
    风云2号G星 = "FY2G",
    风云4号B星 = "FY4B",
    葵花8 = "Himawari-8",
    风云3号D星 = "FY3D",
    风云3号E星 = "FY3E",
    风云3号F星 = "FY3F",
    风云3号G星 = "FY3G",
};


export enum Enum__Fy3IrcUserApiType {
    查询极轨卫星产品 = "http://172.22.68.251/cmms-ws/api/SATES/getPolarSatelliteProduct",
    查询静止卫星产品 = "http://172.22.68.251/cmms-ws/api/SATES/getGeostationarySatelliteProduct",
}

export interface I_Fy3IrcTextureItemAction extends I_Fy3IrcTextureItem {
    /** 状态：（是否点击） */
    State: boolean,
}
